import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { webcams } from '../data/links';

// Embeds the resort's ipcamlive players directly instead of the full
// tellurideskiresort.com page, so the video fills the frame at 16:9.
const Webcams = ({ onExternalLink }) => {
  const [active, setActive] = useState(webcams[0]);

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-3" role="tablist" aria-label="Choose a webcam">
        {webcams.map((cam) => {
          const selected = cam.alias === active.alias;
          return (
            <button
              key={cam.alias}
              role="tab"
              aria-selected={selected}
              onClick={() => setActive(cam)}
              className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                selected
                  ? 'bg-[var(--accent)] text-white'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
              }`}
            >
              {cam.name}
            </button>
          );
        })}
      </div>
      <div className="relative aspect-video rounded-xl overflow-hidden bg-black">
        <iframe
          key={active.alias}
          title={`${active.name} webcam`}
          className="absolute inset-0 w-full h-full"
          src={`https://g1.ipcamlive.com/player/player.php?alias=${active.alias}&autoplay=1`}
          allow="autoplay; fullscreen"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <p className="mt-2 text-xs text-gray-500 dark:text-gray-400 flex items-center justify-between gap-4">
        <span>{active.description}</span>
        <a
          href={active.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => onExternalLink && onExternalLink(active.name, active.url)}
          className="inline-flex items-center gap-1 whitespace-nowrap hover:text-[var(--accent)]"
        >
          All resort cams <ExternalLink className="h-3 w-3" />
        </a>
      </p>
    </div>
  );
};

export default Webcams;
